const { UPDATE_PREVIEW_SCALE } = require("./types");

export const updatePreviewScale = (previewScale) => async (dispatch) => {
  dispatch({
    type: UPDATE_PREVIEW_SCALE,
    payload: { previewScale },
  });
};
